/**
 * The provider's identity payload is a raw JSON string with no guaranteed shape,
 * so an unparsable or region-less identity is expected, not exceptional.
 */
export const getScanResourceRegion = (identity: string): string | undefined => {
  try {
    const parsed: unknown = JSON.parse(identity);

    if (typeof parsed !== "object" || parsed === null || !("region" in parsed)) {
      return undefined;
    }

    const { region } = parsed;

    return typeof region === "string" && region.length > 0 ? region : undefined;
  } catch {
    return undefined;
  }
};
